/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sw_Nav_Stock_Out_NotesInputs */

const vi_sw_nav_stock_out_notes = /** @type {(inputs: Sw_Nav_Stock_Out_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách PXK`)
};

/**

* @param {Sw_Nav_Stock_Out_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sw_nav_stock_out_notes = /** @type {((inputs?: Sw_Nav_Stock_Out_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sw_Nav_Stock_Out_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sw_nav_stock_out_notes(inputs)
});